<template>
    <div class="add-account-page">
        <header class="top-nav">
            <button type="button" class="back-btn" @click="$router.go(-1)">
                <van-icon name="arrow-left" />
            </button>
            <div class="nav-title">{{ getLabel('pageAddWallet.navTitle', '新增提现账户') }}</div>
        </header>

        <main class="page-content">
            <section class="section-block">
                <label class="section-label">{{ getLabel('pageAddWallet.accountType', '账户类型') }}</label>
                <div class="dropdown-wrap">
                    <button type="button" class="select-trigger" @click="walletDropdownOpen = !walletDropdownOpen">
                        <span :class="{ placeholder: !selectedWalletLabel }">
                            {{ selectedWalletLabel || getLabel('pageAddWallet.selectAccountType', '请选择账户类型') }}
                        </span>
                        <van-icon :name="walletDropdownOpen ? 'arrow-up' : 'arrow-down'" />
                    </button>

                    <div v-if="walletDropdownOpen" class="select-list">
                        <button
                            v-for="item in wallets"
                            :key="item.wid"
                            type="button"
                            class="select-item"
                            @click="selectWallet(item)"
                        >
                            <strong>{{ item.text }}</strong>
                            <small>{{ walletTypeText(item.type) }}</small>
                        </button>
                    </div>
                </div>
            </section>

            <section v-if="type == 1 || type == 2 || type == 3" class="form-card">
                <div class="form-group">
                    <label class="field-label">{{ accountFieldLabel }}</label>
                    <div class="input-wrap">
                        <input
                            v-model.trim="bank.account"
                            type="text"
                            class="text-input"
                            :placeholder="accountPlaceholder"
                        >
                    </div>
                </div>

                <div class="upload-block">
                    <div class="upload-label">{{ uploadTitle }}</div>
                    <van-uploader
                        v-model="fileList"
                        multiple
                        :max-count="1"
                        class="uploader"
                        :max-size="2 * 1024 * 1024"
                        @oversize="onOversize"
                        :after-read="afterRead"
                        :before-read="beforeRead"
                    >
                        <div v-if="!fileList.length" class="upload-placeholder">
                            <van-icon name="photograph" class="upload-icon" />
                            <span>{{ getLabel('pageAddWallet.uploadQr', '上传收款二维码') }}</span>
                        </div>
                    </van-uploader>
                </div>
            </section>

            <section v-if="type == 4" class="form-card">
                <div class="form-group">
                    <label class="field-label">{{ getLabel('pageAddWallet.nameLabel', '姓名') }}</label>
                    <div class="input-wrap">
                        <input
                            v-model.trim="bank.name"
                            type="text"
                            class="text-input"
                            :placeholder="$t('accountUsdt.nameEmpty')"
                        >
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">{{ getLabel('pageAddWallet.bankAccountLabel', '银行卡号') }}</label>
                    <div class="input-wrap">
                        <input
                            v-model.trim="bank.account"
                            type="text"
                            class="text-input"
                            :placeholder="$t('accountUsdt.accountEmpty')"
                        >
                    </div>
                </div>

                <div class="form-group no-margin">
                    <label class="field-label">{{ getLabel('pageAddWallet.openArea', '开户地区') }}</label>
                    <div class="dropdown-wrap">
                        <button type="button" class="select-trigger" @click="bankDropdownOpen = !bankDropdownOpen">
                            <span :class="{ placeholder: !selectedBankLabel }">
                                {{ selectedBankLabel || getLabel('pageAddWallet.selectOpenArea', '请选择开户地区') }}
                            </span>
                            <van-icon :name="bankDropdownOpen ? 'arrow-up' : 'arrow-down'" />
                        </button>

                        <div v-if="bankDropdownOpen" class="select-list bank-list">
                            <button
                                v-for="item in banks"
                                :key="item.wid"
                                type="button"
                                class="select-item"
                                @click="selectBank(item)"
                            >
                                <strong>{{ item.text }}</strong>
                                <small>{{ item.code }}</small>
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section class="notice-card">
                <van-icon name="info-o" />
                <div>
                    <strong>{{ getLabel('pageAddWallet.noticeTitle', '重要提示') }}</strong>
                    <p>{{ getLabel('pageAddWallet.noticeText', '请确保账户信息真实有效，新增后将用于提现选择。二维码图片仅支持 JPG / PNG，且大小不能超过 2MB。') }}</p>
                </div>
            </section>

            <button type="button" class="submit-btn" @click="submitBtn">
                {{ getLabel('pageAddWallet.submitSave', '提交保存') }}
            </button>
        </main>
    </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import Api from "../../interface/index";
import { Icon, Uploader, Toast } from "vant";
import axios from "axios";

Vue.use(Icon);
Vue.use(Uploader);
Vue.use(Toast);

export default {
    name: "addcountUsdt",
    data() {
        return {
            bank: {
                account: "",
                name: "",
                area: "",
                bank: "",
                img: "",
                type: 1,
                banks_id: 0,
                wid: 0,
            },
            fileList: [],
            type: 1,
            value: 0,
            value_bank: 0,
            wallets: [],
            banks: [],
            walletDropdownOpen: false,
            bankDropdownOpen: false,
            appOriginalStyles: null,
            bodyOriginalBackground: "",
        };
    },
    computed: {
        selectedWalletLabel() {
            return this.wallets[this.value] ? this.wallets[this.value].text : "";
        },
        selectedBankLabel() {
            return this.banks[this.value_bank] ? this.banks[this.value_bank].text : "";
        },
        accountFieldLabel() {
            if (this.type == 2) {
                return this.$t("accountUsdt.alipayAccount").replace(/：|:/g, "");
            }
            if (this.type == 3) {
                return this.$t("accountUsdt.wechatAccount").replace(/：|:/g, "").trim();
            }
            return this.$t("account.address");
        },
        accountPlaceholder() {
            if (this.type == 2) {
                return this.$t("accountUsdt.alipayAccountEmpty");
            }
            if (this.type == 3) {
                return this.$t("accountUsdt.wechatAccountEmpty");
            }
            return this.$t("account.addressTit");
        },
        uploadTitle() {
            if (this.type == 2) {
                return this.$t("accountUsdt.alipayQrcode");
            }
            if (this.type == 3) {
                return this.$t("accountUsdt.wechatQrcode");
            }
            return this.getLabel("pageAddWallet.uploadWalletQr", "上传钱包二维码");
        },
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        this.applyFullScreenLayout();
        this.start();
        document.addEventListener("click", this.handleDocumentClick);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleDocumentClick);
        this.restoreFullScreenLayout();
    },
    methods: {
        getLabel(key, defaultText) {
            return this.$te(key) ? this.$t(key) : defaultText;
        },
        applyFullScreenLayout() {
            const app = document.getElementById("app");
            if (!app) {
                return;
            }
            this.appOriginalStyles = {
                maxWidth: app.style.maxWidth,
                width: app.style.width,
                margin: app.style.margin,
                backgroundColor: app.style.backgroundColor,
                paddingBottom: app.style.paddingBottom,
            };
            this.bodyOriginalBackground = document.body.style.background;
            app.style.maxWidth = "100%";
            app.style.width = "100%";
            app.style.margin = "0";
            app.style.backgroundColor = "#000000";
            app.style.paddingBottom = "0";
            document.body.style.background = "#000000";
        },
        restoreFullScreenLayout() {
            const app = document.getElementById("app");
            if (app && this.appOriginalStyles) {
                app.style.maxWidth = this.appOriginalStyles.maxWidth || "";
                app.style.width = this.appOriginalStyles.width || "";
                app.style.margin = this.appOriginalStyles.margin || "";
                app.style.backgroundColor = this.appOriginalStyles.backgroundColor || "";
                app.style.paddingBottom = this.appOriginalStyles.paddingBottom || "";
            }
            document.body.style.background = this.bodyOriginalBackground || "";
        },
        start() {
            this.wallets = [];
            this.banks = [];
            Fetch("/user/wallet_type", {}).then((r) => {
                let resData = r.data;
                let wallet = [];
                let banks = [];

                if (Array.isArray(resData)) {
                    wallet = resData;
                } else if (resData) {
                    wallet = resData.wallet || [];
                    banks = resData.banks || [];
                }

                if (wallet.length > 0) {
                    this.bank.bank = wallet[0].name;
                    this.bank.type = wallet[0].type;
                    this.type = wallet[0].type;
                    this.bank.wid = wallet[0].id;
                    for (let i = 0; i < wallet.length; i++) {
                        this.wallets.push({
                            text: wallet[i].name,
                            value: i,
                            type: wallet[i].type,
                            wid: wallet[i].id,
                        });
                    }
                }

                if (banks.length > 0) {
                    for (let i = 0; i < banks.length; i++) {
                        this.banks.push({
                            text: banks[i].name,
                            value: i,
                            code: banks[i].code,
                            wid: banks[i].id,
                        });
                    }
                    if (this.type == 4) {
                        this.bank.banks_id = this.banks[0].wid;
                    }
                }
            });
        },
        submitBtn() {
            Fetch("/user/bank_add", {
                ...this.bank,
            }).then(() => {
                this.$router.go(-1);
            });
        },
        onOversize() {
            this.$toast(this.$t("account.within2megabytes"));
        },
        beforeRead(file) {
            if (file.type !== "image/jpeg" && file.type !== "image/jpg" && file.type !== "image/png") {
                this.$toast(this.$t("account.supportPicture"));
                return false;
            }
            return true;
        },
        afterRead(file) {
            let formData = new FormData();
            formData.append("language", this.$i18n.locale || "zh_cn");
            formData.append("file", file.file);
            formData.append("id", this.$router.history.current.params.id);
            formData.append("token", localStorage.getItem("token"));
            Toast.loading({
                forbidClick: true,
                duration: 20000,
            });
            axios.post(Api.commonUrl + "/api/index/bank_link_upload", formData).then((r) => {
                Toast.clear();
                if (r.data.code === 1) {
                    this.bank.img = r.data.data;
                } else if (r.data.info) {
                    this.$toast(r.data.info);
                } else {
                    this.$toast(this.$t("account.uploadFail"));
                }
            });
        },
        selectWallet(item) {
            this.value = item.value;
            this.type = item.type;
            this.bank.bank = item.text;
            this.bank.type = item.type;
            this.bank.wid = item.wid;
            this.walletDropdownOpen = false;
            this.fileList = [];
            this.bank.img = "";
            if (this.bank.type == 4 && this.banks.length) {
                this.value_bank = 0;
                this.bank.banks_id = this.banks[0].wid;
            }
        },
        selectBank(item) {
            this.value_bank = item.value;
            this.bank.banks_id = item.wid;
            this.bankDropdownOpen = false;
        },
        walletTypeText(type) {
            if (type == 2) {
                return "Alipay";
            }
            if (type == 3) {
                return "WeChat";
            }
            if (type == 4) {
                return "Bank Card";
            }
            return "Crypto Wallet";
        },
        handleDocumentClick(event) {
            if (!this.$el) {
                return;
            }
            const walletWrap = this.$el.querySelector(".section-block .dropdown-wrap");
            const bankWrap = this.$el.querySelector(".form-card .dropdown-wrap");
            if (this.walletDropdownOpen && walletWrap && !walletWrap.contains(event.target)) {
                this.walletDropdownOpen = false;
            }
            if (this.bankDropdownOpen && bankWrap && !bankWrap.contains(event.target)) {
                this.bankDropdownOpen = false;
            }
        },
    },
};
</script>

<style lang="less" scoped>
.add-account-page {
    min-height: 100vh;
    background: #000;
    color: #fff;
}

.top-nav {
    position: sticky;
    top: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(12px);
}

.back-btn {
    position: absolute;
    left: 16px;
    top: 50%;
    width: 28px;
    height: 28px;
    margin-top: -14px;
    border: 0;
    background: transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn .van-icon {
    font-size: 22px;
}

.nav-title {
    font-size: 18px;
    font-weight: 700;
}

.page-content {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 24px 14px 30px;
    box-sizing: border-box;
}

.section-block {
    margin-bottom: 20px;
}

.section-label,
.field-label {
    display: block;
    margin: 0 0 12px 2px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
}

.form-card,
.notice-card {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(12px);
}

.form-card {
    padding: 18px 16px;
    margin-bottom: 22px;
}

.form-group {
    margin-bottom: 18px;
}

.form-group.no-margin {
    margin-bottom: 0;
}

.dropdown-wrap {
    position: relative;
}

.select-trigger,
.input-wrap {
    width: 100%;
    min-height: 52px;
    padding: 0 16px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.03);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
}

.select-trigger span {
    font-size: 15px;
}

.select-trigger .placeholder {
    color: rgba(255, 255, 255, 0.35);
}

.select-trigger .van-icon {
    color: rgba(255, 255, 255, 0.45);
    font-size: 20px;
}

.select-list {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 8px);
    z-index: 40;
    overflow: hidden;
    max-height: 260px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 16px;
    background: rgba(100, 100, 100, 0.58);
    backdrop-filter: blur(18px);
}

.bank-list {
    max-height: 240px;
    overflow-y: auto;
}

.select-item {
    width: 100%;
    padding: 14px 16px;
    border: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background: transparent;
    color: #fff;
    text-align: left;
}

.select-item:last-child {
    border-bottom: 0;
}

.select-item strong {
    display: block;
    font-size: 14px;
    font-weight: 700;
}

.select-item small {
    display: inline-block;
    margin-top: 3px;
    color: rgba(255, 255, 255, 0.42);
    font-size: 11px;
}

.text-input {
    width: 100%;
    border: 0;
    outline: none;
    background: transparent;
    color: #fff;
    font-size: 15px;
}

.text-input::placeholder {
    color: rgba(255, 255, 255, 0.28);
}

.upload-block {
    margin-top: 4px;
}

.upload-label {
    margin-bottom: 12px;
    color: rgba(255, 255, 255, 0.86);
    font-size: 14px;
}

.uploader {
    display: block;
}

.uploader :deep(.van-uploader__wrapper) {
    display: block;
}

.uploader :deep(.van-uploader__preview) {
    margin: 0;
    width: 100%;
    height: 220px;
}

.uploader :deep(.van-uploader__preview-image) {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    object-fit: contain;
    background: rgba(255, 255, 255, 0.02);
}

.upload-placeholder {
    width: 100%;
    height: 220px;
    border: 1px dashed rgba(45, 91, 255, 0.25);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.02);
    color: rgba(255, 255, 255, 0.42);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    box-sizing: border-box;
}

.upload-icon {
    color: #2d5bff;
    font-size: 34px;
}

.notice-card {
    padding: 16px 14px;
    border-left: 4px solid #2d5bff;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 26px;
}

.notice-card .van-icon {
    margin-top: 2px;
    color: #2d5bff;
    font-size: 20px;
    flex-shrink: 0;
}

.notice-card strong {
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
}

.notice-card p {
    margin: 0;
    color: rgba(255, 255, 255, 0.62);
    font-size: 12px;
    line-height: 1.7;
}

.submit-btn {
    width: 100%;
    height: 48px;
    border: 0;
    border-radius: 12px;
    background: linear-gradient(135deg, #2d5bff 0%, #104af0 100%);
    box-shadow: 0 4px 15px rgba(45, 91, 255, 0.3);
    color: #fff;
    font-size: 15px;
    font-weight: 700;
}
</style>
